export default __webpack_public_path__ + "static/media/s-11.e93c10f2.jpg";